import React from "react";
import design from "../../assets/imgs/design.jpg";

import Aux from "../../hoc/Aux";

export default function TileDetails(props) {
  return props.tileDetails != null ? (
    <Aux>
      <div className="modal__fade"></div>
      <div className="modal__container">
        <h1 className="modal__title">{props.tileDetails.title}</h1>
        <a className="modal__overview" href={props.tileDetails.linkToWebsite}>
          {props.tileDetails.callToActionText}
        </a>
        <p className="modal__info">{props.tileDetails.description}</p>

        {/* Gallery Section */}
        {props.tileDetails.artwork && props.tileDetails.artwork.length > 0 && (
          <div className="modal__gallery">
            {props.tileDetails.artwork.map((image, index) => (
              <div key={index} className="modal__gallery__item">
                <img src={image} alt={`Artwork ${index + 1}`} />
              </div>
            ))}
          </div>
        )}
      </div>
    </Aux>
  ) : (
    <></>
  );
}
